export default "__VITE_ASSET__950083c6__"